import React, { useState } from "react";
import { Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { getProfileURL } from "../../../../utils/profile-url";
import { useChatDispatch } from "../../hooks/reduxHook";
import { AvatarStyle, ToastMessageStyled } from "../../style";
import { ChatMessage } from "../../types";
import { ConversationTypeEnum } from "../../types/enums";
import ActionIconButton from "../Buttons/ActionIconButton";
import { handleClickNotify } from "./NotifyHelper";
import clsx from "clsx";

export const ToastMessage = ({
  userInfoId,
  message,
  photofile,
  closeToast,
}: {
  userInfoId: string;
  message: ChatMessage;
  photofile: string;
  closeToast: () => void;
}) => {
  const dispatch = useChatDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const clickHandler = () => {
    if (message?.type === ConversationTypeEnum.PERSONAL) {
      setIsLoading(true);
      dispatch(handleClickNotify(userInfoId, message))
        .then(() => {
          toast.dismiss();
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      closeToast();
    }
  };

  return (
    <ToastMessageStyled
      className={clsx(
        "land-box-tiny toast-notify d-flex flex-row-reverse align-items-center text-light z-3 px-4 gap-1",
        {
          "user-select-none": message?.type !== ConversationTypeEnum.PERSONAL,
        }
      )}
      onClick={clickHandler}
    >
      <ActionIconButton
        type="close-notif"
        toggleClick={(e) => {
          e.stopPropagation();
          closeToast();
        }}
      />
      <div className="d-flex flex-row align-items-center gap-2">
        <div
          className="d-flex flex-row align-items-center justify-content-end gap-2"
          id="toast-message"
        >
          {isLoading && <Spinner animation="border" size="sm" />}

          <div className="d-flex flex-column align-items-center justify-content-center">
            <p
              className="m-0 text-truncate fw-bolder fs-med"
              style={{ direction: "ltr", textAlign: "left" }}
            >
              {message?.senderData?.username}
            </p>
            <p
              className="m-0 text-truncate fw-bolder fs-med"
              style={
                /[ء-ی]/.test(message?.message.charAt(0))
                  ? { direction: "rtl", textAlign: "right" }
                  : { direction: "ltr", textAlign: "left" }
              }
            >
              {message?.message}
            </p>
          </div>
        </div>
        <div className="w-fit">
          <div
            style={
              photofile
                ? {
                    backgroundImage: "url(/assets/images/avatar-bg-1.png)",
                    width: "50px",
                    height: "50px",
                  }
                : {
                    width: "50px",
                    height: "50px",
                  }
            }
            className="main-avatar"
          >
            {photofile && (
              <AvatarStyle
                width={50}
                height={50}
                alt="avatar"
                src={getProfileURL(message?.senderId!, photofile!)}
                className="circle me-2 "
              />
            )}
          </div>
        </div>
      </div>
    </ToastMessageStyled>
  );
};
